import 'simplelightbox/dist/simple-lightbox.jquery.min';
import 'slick-carousel/slick/slick';
import 'slick-lightbox-latest/dist/slick-lightbox.min';
import gtag from '../../tracker/gtag';
import gtag_event from './gtag-init';
import './whatsapp-submission';
import './virtual-submission';
import './faq-submission';
import './compare-property';
import '../../util/lazy-load';
import '../../global/pseudochat';
import '../../global/popup';
import {set_active_anchor_menu_onscroll, set_condition_anchor_menu} from '../../global/anchor-menu';

export default {
  init() {
    // <!------------------ Event Tracker
    // track pageview
    setTimeout(function() {
      gtag_event('Visit');
    }, 1500);
    
    // scroll event
    var content = $('section');
    var current_section_id = null;
    $(window).on('scroll', function () {
      let el = content.filter(function (i, el) {
        return el.getBoundingClientRect().bottom >= parseInt($(el).css('height'))
      });
      let section_id = el.prev().is(content) ? el.prev('section').attr('id') : content.eq(-1).attr('id');

      set_active_anchor_menu_onscroll(el);

      if (section_id != current_section_id) {
        current_section_id = section_id;

        // track pageview
        gtag_event('Vertical Scroll', current_section_id);
      }

      check_scroll_position(current_section_id);
    });

    $(document).ready(function() {
      $('.close-btn-sticky-bar').on('click', function(event) {
        event.stopPropagation();
        $(this).closest('.property-promo').hide();
      });
    
      if ($(window).width() <= 768) {
        $('.property-promo').on('click', function() {
          var promoLink = $(this).find('.details-button').attr('href');
          window.open(promoLink, '_blank');
        });
    
        $('.promo-button').hide();
      }
    });    

    function check_scroll_position(current_section_id) {
      let the_end_of_section = 'section-footer';
      let scroll_height = $(document).height();
      let scroll_position = $(window).height() + $(window).scrollTop();

      if ((scroll_height - scroll_position) / scroll_height === 0 && current_section_id != the_end_of_section) {
        gtag_event('Vertical Scroll', the_end_of_section);
      }
    }
    let scrollOneQuarter = null;
    let scrollHalf = null;
    let scrollThreeQuarter = null;
    let scrollFull = null;
    // let vertical_scroll_event_name = 'Vertical Scroll';
    let floating_wa_btn = document.querySelector('body > div.wa__btn_popup > .wa__btn_popup_icon');

    // Template page-builder use percentage scroll, not section name. Because on page-builder, the section can be more than one on a page.
    $(window).on('scroll', function() {
      // calculate the percentage the user has scrolled down the page
      let scrollPercent = 100 * $(window).scrollTop() / ($(document).height() - $(window).height());

      if (scrollOneQuarter == null && scrollPercent >= 25 && scrollPercent < 50) {
        // gtag_event(vertical_scroll_event_name, 25);
        scrollOneQuarter = 1;
      }

      if (scrollHalf == null && scrollPercent >= 50 && scrollPercent < 75) {
        // gtag_event(vertical_scroll_event_name, 50);
        scrollHalf = 1;
      }

      if (scrollThreeQuarter == null && scrollPercent >= 75 && scrollPercent < 95) {
        // gtag_event(vertical_scroll_event_name, 75);
        scrollThreeQuarter = 1;
      }

      if (scrollFull == null && scrollPercent >= 95) {
        // gtag_event(vertical_scroll_event_name, 100);
        scrollFull = 1;
      }

      //floating wa btn hide show on scroll
      if(scrollPercent == 0 || scrollPercent >= 95) {
        
        if(!floating_wa_btn.classList.contains('btn-chat-box')) {
          floating_wa_btn.classList.add('d-none');
        }
        
        set_condition_anchor_menu('hide');
      }else{
        floating_wa_btn.classList.remove('d-none');
        set_condition_anchor_menu('show');
      }
    });

    // promo img clicked event
    $('.section-promo img').on('click', function() {
      let img_url = $(this).attr('href');
      gtag_event('Promo Image Clicked', img_url);
    });

    $('.section-promo-v2 img').on('click', function() {
      let img_url = $(this).attr('src');
      gtag_event('Promo Image Clicked', img_url);
    });

    // event click about-us img
    $('.section-about-us img').on('click', function() {
      let img_idx = $(this).data('position');
      gtag_event('About-Us Image Clicked', img_idx);
    });


    let galleryElement = $('.gallery-tab a');
    if (galleryElement.length) {
      galleryElement.on('click', function () {
        let tabText = $(this).text();

        gtag_event('Gallery Tab Clicked', $.trim(tabText));
      });
    }

    let clusterElement = $('.cluster-tab a');
    if (clusterElement.length) {
      clusterElement.on('click', function () {
        let tabText = $(this).text();

        gtag_event('Cluster Tab Clicked', $.trim(tabText));
      });
    }

    // image clicked event
    let imageDetails = [
      ['.unit-type img', 'Unit Type Image Clicked'],
    ];

    $.each(imageDetails, function(key, eventDetails) {
      let element = $(eventDetails[0]);
      let eventName = eventDetails[1];

      if (element.length) {
        element.on('click', function() {
          let imgSrc = $(this).attr('src');
          let imgNameIndex = imgSrc.lastIndexOf('/') + 1;
          let imgFilename = imgSrc.substr(imgNameIndex);

          gtag_event(eventName, imgFilename);
        });
      }
    });

    // facility image clicked
    $('.simple-lightbox-facility').on('init', function() {
      $('.facility-slider .slick-slide').on('click', function() {
        let title = $(this).find('.facility-title').text();
        gtag_event('Facility Image Clicked', title);
      });

      $('.facility-slider .slick-arrow.btn-prev').on('click', function() {
        gtag_event('Facility Arrow Clicked', 'prev');
      });

      $('.facility-slider .slick-arrow.btn-next').on('click', function() {
        gtag_event('Facility Arrow Clicked', 'next');
      });
    });

    $(function() {
      // faq clicked event
      $('.section-faq .card-header').on('click', function() {
        gtag_event('FAQ Clicked', $(this).attr('id'));
      });

      // footer menu clicked event
      $('#section-footer .menu-item a').on('click', function() {
        gtag_event('Footer Menu Clicked', $(this).text());
      });

      $('section.banner-v2-carousel .container .banner-image .btn-virtual-tour-lead').on('click', function() {
        let url = $(this).data('url');
        gtag_event('Button VR Clicked', url);
      });

      // cluster / unit v2 section detail clicked

      
      $('#section-cluster-v2 .btn-more').on('click', function () {
        gtag_event('Unit Type More Clicked', 'cluster');
    });

      // logo click
      $('#main_navbar .logo-wrap img').on('click', function() {
        gtag_event('Navbar Logo Clicked');
      });

      // article click
      $('.section-article .post a').on('click', function() {
        let url = $(this).attr('href');
        gtag_event('Article Clicked', url);
      });

      // gallery image click
      $('.section-gallery .gallery-item a').on('click', function() {
        let url = $(this).attr('href');
        gtag_event('Gallery Image Clicked', url);
      });

      // project recommendation click
      $('.section-recommendation-projects .project-card a').on('click', function() {
        let url = $(this).attr('href');
        gtag_event('Project Recommendation Clicked', url);
      });

      // about us clicked event
      $('.section-about-us .btn .show-more').on('click', function() {
        gtag_event('About Us More Clicked', 'about-us');
      });
    });
    // ------------------!> The End of Event Tracker

    // image gallery
    let i;
    let elementLightBoxGeneral;
    let elementLightBoxClusterV1;
    let elementLightBoxClusterV2;
    let elementLightBoxSellingV3;
    let elementLightBoxAboutUSV2;

    for (i = 1; i <= 20; i++) {
      elementLightBoxGeneral = $('.simple-lightbox-' + i + ' a');
      elementLightBoxClusterV1 = $('.simple-lightbox-cluster-' + i + ' a');
      elementLightBoxClusterV2 = $('.simple-lightbox-clusterv2-' + i + ' a');
      elementLightBoxSellingV3 = $('.simple-lightbox-sellingv3-' + i + ' a');
      elementLightBoxAboutUSV2 = $('.simple-lightbox-about-usv2-' + i + ' a');
      if (elementLightBoxGeneral.length) {
        elementLightBoxGeneral.simpleLightbox();
      }
      if (elementLightBoxClusterV1.length) {
        elementLightBoxClusterV1.simpleLightbox();
      }
      if (elementLightBoxClusterV2.length) {
        elementLightBoxClusterV2.simpleLightbox();
      }
      if (elementLightBoxSellingV3.length) {
        elementLightBoxSellingV3.simpleLightbox();
      }
      if (elementLightBoxAboutUSV2.length) {
        elementLightBoxAboutUSV2.simpleLightbox();
      }
    }

    $('.bannerv2-slider').on('init', function(){
      $('.banner-content').removeClass('d-none');
    });

    $('.bannerv2-slider').on('beforeChange', function(){
      if(false === is_mobile()) {
        $('.bannerv2-slider div.slick-list').css('width', 'inherit');
      }
    });

    $('.bannerv2-slider').not('.slick-initialized').slick({
      lazyLoad: 'ondemand',
      mobileFirst: true,
      autoplay: true,
      autoplaySpeed: 5000,
      infinite: true,
      arrows: true,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '<button type="button" class="btn btn-sm btn-arrow btn-prev"><svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.66019e-07 12C4.7928e-07 11.6737 0.13069 11.3474 0.392071 11.0986L12.0514 -8.90479e-08L13.9453 1.80286L3.23298 12L13.9453 22.1971L12.0514 24L0.392071 12.9014C0.13069 12.6526 4.52759e-07 12.3263 4.66019e-07 12Z" fill="#64666e"/></svg></button>',
      nextArrow: '<button type="button" class="btn btn-sm btn-arrow btn-next"><svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M14 12C14 11.6737 13.8693 11.3474 13.6079 11.0986L1.94863 -8.90479e-08L0.0546876 1.80286L10.767 12L0.0546884 22.1971L1.94863 24L13.6079 12.9014C13.8693 12.6526 14 12.3263 14 12Z" fill="#64666e"/></svg></button>',
      responsive: [{
        breakpoint: 1024,
        settings: {
          arrows: true,
          slidesToShow: 1,
        },
      }, {
        breakpoint: 767,
        settings: {
          arrows: false,
          slidesToShow: 1,
        },
      }, {
        breakpoint: 300,
        settings: {
          arrows: false,
          slidesToShow: 1,
        },
      }],
    });

    // slick carousel settings
    $('.facility-slider').not('.slick-initialized').slick({
      mobileFirst: true,
      infinite: true,
      arrows: true,
      prevArrow: '<button type="button" class="btn btn-sm btn-light btn-arrow btn-prev">&lt;</button>',
      nextArrow: '<button type="button" class="btn btn-sm btn-light btn-arrow btn-next">&gt;</button>',
      responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      }, {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
        },
      }, {
        breakpoint: 300,
        settings: {
          slidesToShow: 1,
        },
      }],
    });

    $('.about-us-slider').not('.slick-initialized').slick({
      mobileFirst: true,
      infinite: true,
      arrows: true,
      dots: true,
      prevArrow: '<button type="button" class="btn btn-sm btn-arrow btn-prev"><svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.66019e-07 12C4.7928e-07 11.6737 0.13069 11.3474 0.392071 11.0986L12.0514 -8.90479e-08L13.9453 1.80286L3.23298 12L13.9453 22.1971L12.0514 24L0.392071 12.9014C0.13069 12.6526 4.52759e-07 12.3263 4.66019e-07 12Z" fill="#fafafa"/></svg></button>',
      nextArrow: '<button type="button" class="btn btn-sm btn-arrow btn-next"><svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M14 12C14 11.6737 13.8693 11.3474 13.6079 11.0986L1.94863 -8.90479e-08L0.0546876 1.80286L10.767 12L0.0546884 22.1971L1.94863 24L13.6079 12.9014C13.8693 12.6526 14 12.3263 14 12Z" fill="#fafafa"/></svg></button>',
      responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
        },
      }, {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      }, {
        breakpoint: 300,
        settings: {
          slidesToShow: 1,
        },
      }],
    });

    $('.project-recommendation-slider').not('.slick-initialized').slick({
      mobileFirst: true,
      infinite: true,
      arrows: true,
      prevArrow: '<button type="button" class="btn btn-sm btn-arrow btn-prev"><svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.66019e-07 12C4.7928e-07 11.6737 0.13069 11.3474 0.392071 11.0986L12.0514 -8.90479e-08L13.9453 1.80286L3.23298 12L13.9453 22.1971L12.0514 24L0.392071 12.9014C0.13069 12.6526 4.52759e-07 12.3263 4.66019e-07 12Z" fill="#8A8D94"/></svg></button>',
      nextArrow: '<button type="button" class="btn btn-sm btn-arrow btn-next"><svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M14 12C14 11.6737 13.8693 11.3474 13.6079 11.0986L1.94863 -8.90479e-08L0.0546876 1.80286L10.767 12L0.0546884 22.1971L1.94863 24L13.6079 12.9014C13.8693 12.6526 14 12.3263 14 12Z" fill="#8A8D94"/></svg></button>',
      responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      }, {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
        },
      }, {
        breakpoint: 300,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '30px',
          slidesToShow: 1.1,
        },
      }],
    });


    // slick carousel settings
    $('.virtual-tour-slides').not('.slick-initialized').slick({
      mobileFirst: true,
      infinite: true,
      arrows: true,
      dots: true,
      lazyLoad: true,
      prevArrow: '<button type="button" class="btn btn-sm btn-light btn-arrow btn-prev"><svg width="18" height="27" viewBox="0 0 18 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.666646 13.3797C0.666646 13.0172 0.822839 12.6546 1.13523 12.3781L15.0698 0.0463866L17.3333 2.04956L4.53053 13.3797L17.3333 24.7099L15.0698 26.7131L1.13523 14.3813C0.822839 14.1049 0.666646 13.7423 0.666646 13.3797Z" fill="white"/></svg></button>',
      nextArrow: '<button type="button" class="btn btn-sm btn-light btn-arrow btn-next"><svg width="18" height="27" viewBox="0 0 18 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.3334 13.3797C17.3334 13.0172 17.1772 12.6546 16.8648 12.3781L2.93022 0.0463866L0.666687 2.04956L13.4695 13.3797L0.666688 24.7099L2.93022 26.7131L16.8648 14.3813C17.1772 14.1049 17.3334 13.7423 17.3334 13.3797Z" fill="white"/></svg></button>',
      slidesPerRow: 1,
    });

    $(window).on('load resize orientationchange', function() {
      $('.reviews').each(function(){
          var $carousel = $(this);
          if (!$carousel.hasClass('slick-initialized')) {
            $carousel.slick({
              mobileFirst: true,
              infinite: false,
              dots: true,
              arrows: false,
              slidesToShow: 1,
              centerMode: true,
              centerPadding: '60px',
              responsive: [
              {
                  breakpoint: 1023,
                  settings: 'unslick',
                },
              {
                breakpoint: 767,
                settings: {
                  centerPadding: '30%',
                },
              },
              {
                breakpoint: 400,
                settings: {
                  centerPadding: '40px',
                },
              },
              {
                breakpoint: 370,
                settings: {
                  centerPadding: '30px',
                },
              },
              {
                breakpoint: 300,
                settings: {
                  centerPadding: '20px',
                },
              }],
            });
        }
      });
    });

    $('.simple-lightbox-facility').slickLightbox();

    // load gmap
    function pageTemplateLoadGmap() {
      let mapContainerClass = '.project-map';
      let mapImgElm = $(mapContainerClass + ' img');
      let mapInputIframeElm = $(mapContainerClass + ' input[type="hidden"]');

      if (! mapImgElm.length || ! mapInputIframeElm.length) {
        return false;
      }

      mapImgElm.on('click', function(){
        // $(mapContainerClass).html( mapInputIframeElm.val() );
        // get relative Map to the clicked element
        const CONTAINER = $(this).parent();
        const IFRAME_ELM = $(this).siblings('input[type="hidden"]')
        CONTAINER.html(IFRAME_ELM.val());

        // send GA tracking
        gtag_event('Map Clicked');
      });
    }
    pageTemplateLoadGmap();

    function is_mobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
        return true;
      }else{
        return false;
      }
    }

    $(window).on('scroll', function() {
        let currentHeight = $(window).scrollTop();
        let headerHeight = 80;
        let elmHeader = $('.site-header');
        let stickyClass = 'sticky-top';
        let stickyClassOn = 'sticky-top-on';

        if (currentHeight > headerHeight && elmHeader.hasClass(stickyClass) && ! elmHeader.hasClass(stickyClassOn)) {
          elmHeader.addClass(stickyClassOn);
        } else if (currentHeight <= headerHeight && elmHeader.hasClass(stickyClass)) {
          elmHeader.removeClass(stickyClassOn);
        }
    });

    $('.cluster-tab-content .btn-more').on('click', function() {
      let unit_class = $(this).data('unit-class');
      let unit_class_changed = '.' + unit_class + ':gt(2)';
      let unit_show = $(this).data('unit-show');
      let class_hide = 'd-none';

      if (unit_show == 0) {
        $(unit_class_changed).removeClass(class_hide);
        $(this).removeClass('more').addClass('less');
      } else {
        $(unit_class_changed).addClass(class_hide);
        $(this).addClass('more').removeClass('less');
      }

      s_cluster_change_btn_more($(this));
    });

    $('.single-cluster-content .btn-more').on('click', function () {
      let unit_class = $(this).data('unit-class');
      let unit_class_changed = '.' + unit_class + ':gt(2)';
      let unit_show = $(this).data('unit-show');
      let class_hide = 'd-none';

      if (unit_show == 0) {
        $(unit_class_changed).removeClass(class_hide);
        $(this).removeClass('more').addClass('less');
      } else {
        $(unit_class_changed).addClass(class_hide);
        $(this).addClass('more').removeClass('less');
      }

      s_cluster_change_btn_more($(this));
    });

    function s_cluster_change_btn_more(btn) {
      if (btn.data('unit-show') == 0) {
        btn.data('unit-show', 1);
        btn.find('span').html('Lihat lebih sedikit');

        // event track
        gtag('Cluster Button Clicked', 'Show More Unit');
      } else {
        btn.data('unit-show', 0);
        btn.find('span').html('Lihat lebih banyak');

        // event track
        gtag('Cluster Button Clicked', 'Show Less Unit');
      }
    }

    $('.unit-detail-link').on('click', function() {
      clone_unit_type($(this).data('unit-id'), $(this).data('pretext'));

      // event track
      gtag_event('Detail Unit Button Clicked', 'unit-'+$(this).data('unit-name'));
    });

    $('#section-cluster .btn-more').on('click', function () {
      gtag_event('Unit Type More Clicked', 'cluster');
  });

    // scroll tracker for modal content
    const modalFooter = jQuery('#unit-type-modal .modal-footer');
    const DELAY = 1200;
    let tolerance = Date.now();

    $('#unit-type-modal .modal-body').scroll(() => {
        if (!modalFooter.hasClass('modal-footer-hidden') && (Date.now() - tolerance) > DELAY) {
          tolerance = Date.now();
          modalFooter.addClass('modal-footer-hidden');
          clearTimeout(jQuery.data(this, 'scrollTimer'));
          jQuery.data(this, 'scrollTimer', setTimeout(() => {
              modalFooter.removeClass('modal-footer-hidden');
          }, 500));
        }
    });


    $('body').on('hidden.bs.modal', () => {
      // NOTE: since the #modalVideoPlayer is always showing, the minimal modal shown is 1
      if($('.modal.show').length > 1) {
        $('body').addClass('modal-open');
      }
    });

    function clone_unit_type(unit_id,pretext) {
      const unit_title_elm = `.unit-type-wrap-${unit_id} .unit-name`;
      const unit_type_elm = `#unit-type-${unit_id}`;
      const unit_detail_elm = `#unit-detail-wrap-${unit_id}`;
      const unit_price_elm = `#unit-type-wrap-${unit_id} .price-installment-holder .value`;
      const container_elm = '#unit-type-modal .unit-type';
      const new_unit_type_id = 'unit-type-clone';
      const new_unit_type_detail_id = 'unit-type-detail-clone';
      const cluster_name = `.unit-type-wrap-${unit_id} .cluster-name`;
      const pretext_wa = pretext;

      // clone content
      $(container_elm).text('');
      $('#unit-type-modal-label').html(`<h4>${$(cluster_name).text()}</h4>`);
      $(unit_type_elm).clone().attr('id', new_unit_type_id).appendTo($(container_elm));
      $(unit_detail_elm).clone().attr('id', new_unit_type_detail_id).appendTo($(container_elm));

      // change id
      $(`#${new_unit_type_id} .carousel-control-prev`).attr('href', `#${new_unit_type_id}`);
      $(`#${new_unit_type_id} .carousel-control-next`).attr('href', `#${new_unit_type_id}`);
      $(`#${new_unit_type_id} .carousel-indicators li`).attr('data-target', `#${new_unit_type_id}`);
      $(`#${new_unit_type_id} .carousel-item`).removeClass('simple-lightbox-2');
      /*
      $('#' + new_unit_type_id + ' .carousel-item').addClass('simple-lightbox-modal-2');
      $('.simple-lightbox-modal-2 a').simpleLightbox();
      */
      $(`#${new_unit_type_detail_id} .description`).removeClass('d-none');
      $(`#${new_unit_type_detail_id} .unit-label`).html(`${$(unit_title_elm).text()}`);
      $(`#${new_unit_type_detail_id} .price-installment .price`).html(`${$(unit_price_elm).first().text()}`);

      $(`#${new_unit_type_id} .carousel-item a`).on('click', () => false);
      $('#unit-type-modal .btn-whatsapp').attr('data-pretext', pretext_wa);
      $('#unit-type-modal').modal('show');
    }

    // unit type modal, when cta clicked
    $(() => {
      $('#unit-type-modal .modal-footer a').on('click', () => {
        $('#unit-type-modal').modal('hide');
      })
    });
      // play video on modal
      var videoSrc;
      var modalVideoPlayerElm = '#modalVideoPlayer';
      var modalVideoIframeElm = '#modalVideoIframe';
      var imageName;

      $('.play-video-on-modal').click(function () {
          videoSrc = $(this).data( 'video-src' );
          imageName = $(this).data( 'image' );
          $(modalVideoIframeElm).attr( 'src', videoSrc + '?autoplay=1&amp;modestbranding=1&amp;showinfo=0' );
          gtag_event('Button Video Clicked', imageName);
          $('.bannerv2-slider').not('.slick-initialized').slick('slickPause');
      });

      // stop playing the youtube video when I close the modal
      $(modalVideoPlayerElm).on('hide.bs.modal', function () {
        $(modalVideoIframeElm).attr('src', videoSrc);

        if(false === is_mobile()) {
          if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
            $('section.banner-v2-carousel, .bannerv2-slider div.slick-list').css({'width': '-moz-available', 'overflow': '-moz-hidden-unscrollable'});
          }else{
            $('.bannerv2-slider div.slick-list').css('width', 'fit-content');
          }
        }else{
          $('section.banner-v2-carousel, .bannerv2-slider div.slick-list').css({'overflow': 'clip'});
        }

      });

    // virtual tour slick carousel settings
    $('.facility-slider').not('.slick-initialized').slick({
      mobileFirst: true,
      infinite: true,
      arrows: true,
      prevArrow: '<button type="button" class="btn btn-sm btn-light btn-arrow btn-prev">&lt;</button>',
      nextArrow: '<button type="button" class="btn btn-sm btn-light btn-arrow btn-next">&gt;</button>',
      responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      }, {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
        },
      }, {
        breakpoint: 300,
        settings: {
          slidesToShow: 1,
        },
      }],
    });

    $('.more-about-us-desc').on('click', function () {
      let targetClass = '.' + $(this).data('section-target');

      $(targetClass).toggleClass('hide-description')
      return false;
    });

    // promo section
    $(function() {
      function countdownTimer(duration, ddays, dhours, dminutes, dseconds) {
        var timer = duration, days, hours, minutes, seconds;
        setInterval(function () {
            days = Math.floor(timer / (60 * 60 * 24));
            hours = Math.floor((timer % (60 * 60 * 24)) / (60 * 60));
            minutes = Math.floor((timer % (60 * 60)) / (60));
            seconds = Math.floor((timer % (60)));

            days = days < 10 ? '0' + days : days;
            hours = hours < 10 ? '0' + hours : hours;
            minutes = minutes < 10 ? '0' + minutes : minutes;
            seconds = seconds < 10 ? '0' + seconds : seconds;

            ddays.text(days);
            dhours.text(hours);
            dminutes.text(minutes);
            dseconds.text(seconds);

            if (--timer < 0) {
                timer = duration;
            }
        }, 1000);
      }

      $('.section-promo-v2 .countdown').each(function () {
        var timeDiff = $(this).data('timediff');
        var tDay = $(`.section-promo-v2 .countdown.td-${timeDiff} .countdown-content>div:nth-child(1)>span:nth-child(1)`);
        var tHour = $(`.section-promo-v2 .countdown.td-${timeDiff} .countdown-content>div:nth-child(2)>span:nth-child(1)`);
        var tMin = $(`.section-promo-v2 .countdown.td-${timeDiff} .countdown-content>div:nth-child(3)>span:nth-child(1)`);
        var tSec = $(`.section-promo-v2 .countdown.td-${timeDiff} .countdown-content>div:nth-child(4)>span:nth-child(1)`);

        if (timeDiff > 0) {
          countdownTimer(timeDiff, tDay, tHour, tMin, tSec);
        }
      });
    });

    // navbar menu section
    $(function() {
      var menuLen = jQuery('#wp-megamenu-page-template-menu:not(.wpmm-mobile-menu) > .wpmm-nav-wrap ul.wp-megamenu > li').length;
      if (menuLen >= 6) {
        jQuery('.site-header .cta-wrap a.btn.compact-mode').addClass('f-compact-mode');
        jQuery('.site-header .cta-wrap a.btn:not(.compact-mode)').hide();
        jQuery('.site-header .cta-wrap a.btn.compact-mode').removeClass('compact-mode');
      }

      // wp megamenu
    });

    if(is_mobile) {
      $('.wpmm-mobile-menu div ul.wp-megamenu').prepend('<li><a href="javascript:;" class="text-right wpmm_mobile_menu_btn show-close-icon menu-active"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.81126 9L0 1.18874L1.18874 0L9 7.81126L16.8113 0L18 1.18874L10.1887 9L18 16.8113L16.8113 18L9 10.1887L1.18874 18L0 16.8113L7.81126 9Z" fill="#A1A2AA"/></svg></a></li>');
    }

    // promov2-slider
    if($('.promov2-slider').length) {
      $('.promov2-slider').slick({
        autoplay: false,
        autoplaySpeed: 5000,
        infinite: true,
        centerMode: true,
        centerPadding: '28.7%',
        slidesToShow: 1,
        dots: true,
        arrows: true,
        prevArrow: '<button type="button" class="btn btn-sm btn-arrow btn-prev"><svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.66019e-07 12C4.7928e-07 11.6737 0.13069 11.3474 0.392071 11.0986L12.0514 -8.90479e-08L13.9453 1.80286L3.23298 12L13.9453 22.1971L12.0514 24L0.392071 12.9014C0.13069 12.6526 4.52759e-07 12.3263 4.66019e-07 12Z" fill="#64666e"/></svg></button>',
        nextArrow: '<button type="button" class="btn btn-sm btn-arrow btn-next"><svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M14 12C14 11.6737 13.8693 11.3474 13.6079 11.0986L1.94863 -8.90479e-08L0.0546876 1.80286L10.767 12L0.0546884 22.1971L1.94863 24L13.6079 12.9014C13.8693 12.6526 14 12.3263 14 12Z" fill="#64666e"/></svg></button>',
        responsive: [{
          breakpoint: 1025,
          settings: {
            centerPadding: '18.7%',
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 769,
          settings: {
            arrows: false,
            centerPadding: '8.7%',
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 480,
          arrows: false,
          settings: {
            arrows: false,
            centerPadding: '8.7%',
            slidesToShow: 1,
          },
        }],
      });
    }

    // location maps / section-v2
    if($('.location-maps').length) {
      const LABEL_MORE = 'Lihat Lebih Banyak <svg width="19" height="12" viewBox="0 0 19 12" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M0.652344 2.08768L2.3494 0.390625L9.75087 7.7921L17.1523 0.390625L18.8494 2.08768L9.75087 11.1862L0.652344 2.08768Z" fill="#FFFFF"/> </svg>';
      const LABEL_LESS = 'Lihat Lebih Sedikit <svg width="19" height="12" viewBox="0 0 19 12" fill="none" version="1.1" id="svg4" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M 0.652344,9.489145 9.75087,0.390625 18.8494,9.489145 17.1523,11.1862 9.75087,3.784725 2.3494,11.1862 Z" fill="#FFFFF" id="path2" /> </svg>';
      $('.location-maps .cta-buttons .see-more').on('click', function(e) {
        e.preventDefault();
        const descriptionDOM = $(this).parent('.cta-buttons').siblings('.location-maps-description');
        descriptionDOM.toggleClass('text-part');

        if (descriptionDOM.hasClass('text-part')) {
          // event See Less
          $(this).html(LABEL_MORE);
          gtag_event('Location Description See Less', 'Location');
        } else {
          // event See More
          $(this).html(LABEL_LESS);
          gtag_event('Location Description See More', 'Location');
        }
      });
    }

    if($('.facility-v2').length) {
      const LABEL_MORE = 'Lihat Lebih Banyak <svg width="19" height="12" viewBox="0 0 19 12" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M0.652344 2.08768L2.3494 0.390625L9.75087 7.7921L17.1523 0.390625L18.8494 2.08768L9.75087 11.1862L0.652344 2.08768Z" fill="#FFFFF"/> </svg>';
      const LABEL_LESS = 'Lihat Lebih Sedikit <svg width="19" height="12" viewBox="0 0 19 12" fill="none" version="1.1" id="svg4" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M 0.652344,9.489145 9.75087,0.390625 18.8494,9.489145 17.1523,11.1862 9.75087,3.784725 2.3494,11.1862 Z" fill="#FFFFF" id="path2" /> </svg>';
      $('.facility-v2 .cta-buttons .see-more').on('click', function(e) {
        e.preventDefault();
        $('.default-invisible').toggleClass('d-none');
        $(this).toggleClass('text-part');

        if ($(this).hasClass('text-part')) {
          // event See Less
          $(this).html(LABEL_MORE);
          gtag_event('Facility See Less');
        } else {
          // event See More
          $(this).html(LABEL_LESS);
          gtag_event('Facility See More');
        }
      });
    }

    if($('.popup').length){

      setTimeout(function(){
        let sectionPopUp = $('#section-popup');
        sectionPopUp.modal('show');
      },1000);

    }
  },
  finalize() {
    // JavaScript to be fired on the page template, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/page-template/page-builder/page.js